import { render, staticRenderFns } from "./Trainingplan.vue?vue&type=template&id=f6146266&scoped=true&"
import script from "./Trainingplan.vue?vue&type=script&lang=js&"
export * from "./Trainingplan.vue?vue&type=script&lang=js&"
import style0 from "./Trainingplan.vue?vue&type=style&index=0&id=f6146266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6146266",
  null
  
)

export default component.exports